// The hover fill of a primary button set to its rest fill, so it shows no hover (index.css, .smycles-button:hover).
const NO_HOVER = "aria-disabled:[--btn-fill-hover:var(--context-inverse)]";

// A primary button that refuses its click while staying in the tab order (`aria-disabled`): it looks locked like the
// page's other switched-off buttons, and its hover fill is its rest fill, so it shows no hover while locked (index.css,
// .smycles-button:hover). "Send" in TurnInput and "Begin story" on the Power choice share it (spark#1236).
export const LOCKED_BUTTON = `aria-disabled:cursor-not-allowed aria-disabled:opacity-50 ${NO_HOVER}`;

// The same button while what it started still runs ("Begin story" while the story is being started): dimmed with no
// hover as when locked, but with the progress cursor, since it waits rather than refuses (spark#1236).
export const BUSY_BUTTON = `aria-disabled:cursor-progress aria-disabled:opacity-50 ${NO_HOVER}`;
